<template>
  <m-c513 class="rounded-pill p-0 w-100" :image="item.image" :alt="item.name">
    <template #p-1>
      <div class="bg-primary ">
        <p class="text-slicer w-100 text-white text-center pt-2 ">
          {{ contentSlicer(item.name, 25) }}</p>
        <b-col lg="12">
          <b-row class="text-center ">

            <b-col class=" py-1">
              <m-a class="text-white" :href="{name:'SingleBrand',params:{slug:item.slug}}">
                <span class="ml-1">محصولات مرتبط</span>
                <b-icon icon="arrow-left-circle"></b-icon>
              </m-a>
            </b-col>
          </b-row>
        </b-col>
      </div>

    </template>
  </m-c513>
</template>

<script>
export default {
  name: "CategoryCard",
  props: ['item']
}
</script>

<style scoped>

</style>